import React from 'react';
import StateDropdownInput from '../common/AddressFields/StateDropdownInput';

const SpouseStateDropdownInput = ({ errors, onChange }) => (
  <StateDropdownInput errors={errors} id="spouse-state-select" loadFrom="spouse" onChange={onChange} validationName="spouseState" />
);

export default SpouseStateDropdownInput;
